import {type CountryCode, parsePhoneNumberFromString} from 'libphonenumber-js';
import {countryAlphaCodesMap} from 'platform/components';

import {isNil} from 'ramda';

const CONTAINS_LETTER = /[a-z]/i;
const NON_DIGIT = /\D/g;
const ALPHA_2_BY_ALPHA_3: Record<string, CountryCode> = countryAlphaCodesMap;

export function parseSellerPhoneNumber(rawNumber: string, countryAlpha3: string | undefined) {
  const internationalNumber = rawNumber.startsWith('00') ? `+${rawNumber.slice(2)}` : rawNumber;
  const country = countryAlpha3 ? ALPHA_2_BY_ALPHA_3[countryAlpha3] : undefined;

  if (internationalNumber.startsWith('+')) {
    return parseValidNumber(internationalNumber);
  }

  if (isNil(country) || CONTAINS_LETTER.test(rawNumber)) {
    return undefined;
  }

  // Scraped numbers often omit '+'. Only trust the dial code when it matches the seller country.
  const asInternationalNumber = parsePhoneNumberFromString(`+${rawNumber.replace(NON_DIGIT, '')}`);

  if (asInternationalNumber?.isValid() && asInternationalNumber.country === country) {
    return asInternationalNumber;
  }

  return parseValidNumber(rawNumber, country);
}

function parseValidNumber(phoneNumber: string, country?: CountryCode) {
  const parsedNumber = parsePhoneNumberFromString(phoneNumber, country);

  return parsedNumber?.isValid() ? parsedNumber : undefined;
}
